import app from "../app";

// Preload links with `<link rel="prefetch">`, but initialize it in javascript so that the
// critical parts of a page can try to load first.

export default (() => {
  app.pageLoad.push(function() {
    var $links = $('[data-rel="prefetch"]');
    var timers = []

    // Don't prefetch on mobile
    if ( app.breakpointIsMobile() ) return;

    if ( !$links.length ) return;

    timers.push(window.setTimeout(function() {
      $links.each(function(index) {
        var $link = $(this);
        var href = $link.attr('data-href');
        var prefetchLinkHTML = `<link rel="prefetch" href="${href}" />`;

        timers.push(window.setTimeout(function() {
          $link.replaceWith(prefetchLinkHTML);
        }, 250 * (index + 1)));
      });
    }, 3000));

    document.addEventListener('turbo:before-cache', () => {
      timers.forEach(function(timer) {
        window.clearTimeout(timer);
      });
    });
  });
})();
